import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
} from '../../types';
import { overTimeSegmentedLineChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeSegmentedLineChartActions,
  OverTimeSegmentedLineChartState,
  OverTimeSegmentedLineChartUiComponentProps,
} from './types';
import { OverTimeSegmentedLineChartUiComponent } from './UiComponent';

import { useOverTimeSegmentedLineChartStateManager } from './useStateManager';

export const overTimeSegmentedLineChartViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeSegmentedVizData,
  OverTimeSegmentedVizExternalProps,
  OverTimeSegmentedLineChartUiComponentProps,
  OverTimeSegmentedLineChartState,
  OverTimeSegmentedLineChartActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeSegmentedLineChartStateManager,
  dataToUiComponentProps: overTimeSegmentedLineChartDataToUiComponentProps,
  UiComponent: OverTimeSegmentedLineChartUiComponent,
};
